export default "{\n    \"overdueTooltip\": \"Invoices that are passed their due date.\",\n    \"overdueLabel\": \"Overdue: {{ amount }}\"\n}\n"